/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module helpers/html
 */
import { globalDocument } from "../../constants.js";
/**
 * Convert special characters to HTML entities
 */
export function htmlspecialchars(html) {
    const tmp = globalDocument.createElement('div');
    tmp.textContent = html;
    return tmp.innerHTML;
}
